import { render, staticRenderFns } from "./BasicDropdownMenu.vue?vue&type=template&id=d7f875da&scoped=true"
import script from "./BasicDropdownMenu.vue?vue&type=script&lang=js"
export * from "./BasicDropdownMenu.vue?vue&type=script&lang=js"
import style0 from "./BasicDropdownMenu.vue?vue&type=style&index=0&id=d7f875da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f875da",
  null
  
)

export default component.exports